export const buildRefCodeDataOrEmpty = (data) => {
    if (!data) {
        return {
            isEmpty: true,
            defaultCode: '',
            defaultCodeTimesUsed: 0,
        };
    }
    const result = {
        isEmpty: data.isEmpty || false,
        defaultCode: data.defaultCode || '',
        defaultCodeTimesUsed: data.defaultCodeTimesUsed || 0,
    };
    return result;
};
